var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sky-input-number"},[_c('itemSearch',_vm._b({},'itemSearch',_vm.$attrs,false),[_c('el-input-number',_vm._b({ref:"input",attrs:{"value":_vm.value},on:{"change":_vm.change}},'el-input-number',_vm.$attrs,false)),_c('div',{attrs:{"slot":"toolTips"},slot:"toolTips"},[_vm._v(_vm._s(_vm.toolContent))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }